import WebSocketClient from './websocket-client.js'
import { socketBus } from '@/eventBus/index.js'
class WebSocketManager {
  constructor () {
    this.client = null // 保存 WebSocketClient 实例
  }

  getInstance (url, maxReconnectAttempts = 5) {
    if (!this.client) {
      console.log('连接不存在，创建新的连接', url)
      this.client = new WebSocketClient(url, maxReconnectAttempts)
      this.client.connect()
      this.client.handleMessage = this.handleMessage // 绑定消息处理函数
    }
    return this.client
  }

  handleMessage (data) {
    try {
      const message = JSON.parse(data) // 解析消息
      console.log('收到消息', message, typeof message)
      if (message === 'The heartbeat packets' || typeof message === 'string') { // 心跳数据，无需处理
        return
      }
      // 使用事件总线广播消息
      socketBus.$emit('websocket-message', message)
    } catch (e) {
      console.error('无法解析数据', data)
    }
  }

  close () {
    if (this.client) {
      this.client.close()
      this.client = null
    }
  }
}

const websocketManager = new WebSocketManager()
export default websocketManager
